<template>
  <b-modal id="curriculum" v-model="open" @close="closeCurriculum" hide-footer>
    <template v-slot:modal-header>
      <b-button-close @click="closeCurriculum" />
    </template>
    <b-container fluid class="p-0" v-if="open">
      <b-row>
        <b-col sm="4">
          <div class="text-center">
            <div class="avatar-wrapper mb-3 position-relative">
              <b-img
                :src="member.professionalProfile"
                class="object-fit-cover rounded-circle"
              ></b-img>
              <b-img
                :src="member.personalProfile"
                class="object-fit-cover rounded-circle smooth-shadow profile"
              ></b-img>
            </div>
            <h4 class="font-weight-bold color-darken-1">{{ member.name }}</h4>
            <h5 class="font-weight-light">{{ member.position }}</h5>
            <b-button
              v-if="member.cv"
              class="bg-color-darken-1 rounded-pill smooth-shadow border-0 px-4 py-2 mt-4 mb-3 mb-sm-0"
              @click="downloadCV(member.cv, member.name)"
            >
              Descargar CV
            </b-button>
          </div>
        </b-col>
        <b-col sm="8" class="pl-sm-4 pl-md-5">
          <p v-html="member.description" class="h5 font-weight-light mt-4"></p>
          <div
            v-if="member.phrase"
            class="text-center p-3 p-sm-5 mt-3 mt-sm-4 phrase"
            :style="`background-image: url(${require('@/assets/quotes-bg.svg')})`"
          >
            <span
              v-html="`“${member.phrase}”`"
              class="h4 font-weight-bold color-base"
            ></span>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: "Curriculum",
  props: {
    member: Object,
    open: Boolean
  },
  data() {
    return {
      hoverAvatar: false
    };
  },
  methods: {
    closeCurriculum() {
      this.$emit("close");
    },
    downloadCV(fileURL, fileName) {
      // for non-IE
      if (!window.ActiveXObject) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
        save.download = fileName || filename;
        if (
          navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
          navigator.userAgent.search("Chrome") < 0
        ) {
          document.location = save.href;
          // window event not working here
        } else {
          var evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false
          });
          save.dispatchEvent(evt);
          (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      }

      // for IE < 11
      else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, "_blank");
        _window.document.close();
        _window.document.execCommand("SaveAs", true, fileName || fileURL);
        _window.close();
      }
    }
  }
};
</script>

<style lang="sass">
#curriculum
  display: flex !important
  justify-content: center
  align-items: center
  .modal
    &-dialog
      /*width: calc(100vw - 20rem)*/
      /*max-width: unset*/
      /*height: calc(100vh - 8rem)*/
      /*max-height: unset*/
      width: 1018px
      max-width: 90vw
      height: 490px
      max-height: 80vh
      margin: 0
    &-header
      border: 0
    &-content
      width: 100%
      height: 100%
      border-radius: 0
      border: 0
    &-body
      padding: 2rem 4rem
      background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(248,248,248,1) 100%)
      @media screen and (max-width: 768px)
        padding: 2rem !important
      .avatar-wrapper
        img
          width: 100%
          max-width: 200px
          &:first-child
            position: absolute
            top: 0
            left: 50%
            transform: translateX(-50%)
            height: 100%
            opacity: 1
            transition: opacity 0.5s ease
            animation: fadeInterval 12s ease-out infinite;
            // &:hover
            //   opacity: 0
              // & + img
                // box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.16)
        .profile
          border: 1px solid white
        /*img:last-child*/
          /*border: 3px solid white*/
      .phrase
        /*border-left: 4px solid #ACB7A1*/
        background-repeat: no-repeat
        background-position: center center
        background-size: 95%
        /*background-color: #f8f8f8*/
  @media screen and (max-width: 502px)
    align-items: flex-start
    padding: 1rem 0 0 0 !important
    .modal
      &-body
        padding: 1rem
        text-align: center
        .phrase
          background-image: none !important
    .h5
      font-size: 1.125rem
    .h4
      font-size: 1.25rem

@keyframes fadeInterval
  0%, 60%
    opacity: 1
  60%
    opacity: 1
  70%, 90%
    opacity: 0
  100%
    opacity: 1
</style>
